import React from "react";

import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";

import App from "./App";
import AppErrorFallback from "./Components/ErrorBoundary/AppErrorFallback";
import { ToastProvider } from "./Components/Toast";
import reportWebVitals from "./reportWebVitals";
import { setupInterceptors } from "./Services/AxiosInterceptors";
import Store from "./Store/Store";
import { getPostHogKey } from "./Utils/runtimeEnv";
import "./Styles/fonts.scss";
import "./Styles/tailwind.scss";
import "./Styles/main.scss";

const POSTHOG_HOST = "https://us.i.posthog.com";
const posthogKey = getPostHogKey();
const isAnalyticsEnabled = !!posthogKey;

if (isAnalyticsEnabled) {
  posthog.init(posthogKey, {
    api_host: POSTHOG_HOST,
    defaults: "2026-05-30",
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
setupInterceptors();

const handleAppError = (error: unknown, info: React.ErrorInfo) => {
  if (isAnalyticsEnabled) {
    posthog.captureException(error, {
      componentStack: info.componentStack,
    });
  }
};

const app = (
  <ErrorBoundary FallbackComponent={AppErrorFallback} onError={handleAppError}>
    <Provider store={Store}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </Provider>
  </ErrorBoundary>
);

root.render(
  isAnalyticsEnabled ? (
    <PostHogProvider client={posthog}>{app}</PostHogProvider>
  ) : (
    app
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
